import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { GET_COMMENT_REPLIES } from 'root/src/shared/descriptions/endpoints/endpointIds'
import addCommentReplies from 'root/src/client/logic/comment/actions/addCommentReplies'

export default payload => async (dispatch) => {
	const { parentId } = payload
	const { body, statusCode } = await dispatch(
		apiRequest(GET_COMMENT_REPLIES, payload),
	)

	if (statusCode === 200) {
		dispatch(addCommentReplies({ items: body.items, parentId }))
		return body.lastKey
	}

	return undefined
}
